module.exports = __webpack_public_path__ + "img/t2-8.7082fa88.svg";